import React, { useRef, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import WpAPI from '../../WpApi';
import HelpOptions from '../common/HelpOptions';
import HelpForm from '../common/HelpForm';
import '../../assets/scss/common/_helpbox.scss';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'; // Uncomment this while using Google reCaptcha V3
import { RECAPTCHA_SITE_KEY } from '../../constants/constants'; // Uncomment this while using Google reCaptcha V3
import { isLocalStorageAvailable } from '../../helper';
const HelpBox = (props) => {
    const rhistory = useHistory();
    const rlocation = useLocation();
    const [option, setOption] = useState();
    const [openHelpBox, setOpenHelpBox] = useState(false);
    const [showHelpBox, setShowHelpBox] = useState(true);
    const [hideInRight, setHideInRight] = useState(false);
    const [toggleBox, setToggleBox] = useState(false);
    const [loader, setLoader] = useState(true);

    const setHelpToggleCookie = (value) => {
        localStorage.setItem('is_open', value);
        setToggleBox(value);
    }

    useEffect(() => {
        setTimeout(() => {
          setLoader(false);
        }, 500)
      }, [])

    useEffect(() => {
        let isOpen = null;
        if(isLocalStorageAvailable()){
            isOpen = localStorage.getItem('is_open');
            // Check storage usage before getting the item
            const localStorageQuota = 5 * 1024 * 1024; // Calculate localStorageQuota. Roughly 5MB limit
            if (localStorage.length < localStorageQuota) {
                isOpen = localStorage.getItem('is_open');
            } else {
                console.warn("Local storage limit reached. Consider clearing some data.");
            }
        }
        if (isOpen != null && isOpen == 'open') {
            setToggleBox(isOpen);
            setOpenHelpBox(true);
        } else {
            setToggleBox(isOpen);
        }

        let helpSubject = null;
        if(isLocalStorageAvailable()){
            helpSubject = localStorage.getItem('help_subject');
            // Check storage usage before getting the item
            const localStorageQuota = 5 * 1024 * 1024; // Calculate localStorageQuota. Roughly 5MB limit
            if (localStorage.length < localStorageQuota) {
                helpSubject = localStorage.getItem('help_subject');
            } else {
                console.warn("Local storage limit reached. Consider clearing some data.");
            }
        }
        if (helpSubject != null) {
            setOption(helpSubject);
        }
    }, []);

    const  validateHelpBox = () => {
        const pathname_1 = location.pathname.split("/")[1];
        const pathname_2 = location.pathname.split("/")[2];
        if(location.pathname == '/'){
            setShowHelpBox(true);
        }else if(pathname_1 != '' && pathname_2 == ''){
            switch(pathname_1){
                // Will display only dashboard and my-account page Ticket#646
                case 'my-account':
                    setShowHelpBox(true);
                    break;
                default:
                    setShowHelpBox(false);
                    break;
                /*//case 'create-resume':
                //case 'choose-template':
                case 'quick-editor':
                //case 'my-account':
                //case 'edit-profile':
                //case 'invoices':
                //case 'membership':
                    setShowHelpBox(true);
                    break;
                default:
                    setShowHelpBox(false);
                    break; */
            }
        }else if(pathname_2){
            setShowHelpBox(false);
            // switch(pathname_2){
            //     case 'allinone':
            //     case 'details':
            //     case 'work-history':
            //     case 'education':
            //     case 'skills':
            //     case 'additional-sections':
            //         setShowHelpBox(false);
            //         break;
            //     default:
            //         setShowHelpBox(true);
            //         break; 
            // }
        }
    }

    useEffect(() => {
        location.pathname && validateHelpBox();
    }, [location.pathname])

    return (<>
        {(showHelpBox && !loader) && <div data-acsb-navigable="true" className={`${hideInRight ? 'shift-right' : ''} helpbox-wrap no-print ${(openHelpBox && toggleBox == 'open') ? 'help-opened' : 'help-closed'}`}>
            {openHelpBox ? <>
                <div className="helpbox-new" data-acsb-navigable="true">
                    <div className="helpbox-header">
                        <h4>Get in Touch!</h4>
                        <p>Want to find out more about Resumetemplates.com? Get in touch with us by filling up this form.</p>
                    </div>
                    {option ?
                    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
                        <HelpForm
                            option={option}
                            setOpenHelpBox={(v) => setOpenHelpBox(v)}
                            setOption={(option) => { setOption(option) }} 
                        />
                    </GoogleReCaptchaProvider>
                    : <HelpOptions
                        option={option}
                        setOption={(option) => { setOption(option) }}
                        setOpenHelpBox={(v) => setOpenHelpBox(v)} 
                    />
                }
                </div>
            </> : ''}

            <div className="help-link">
                <span className="mob-close" onClick={() => {
                    setHideInRight(!hideInRight);
                    openHelpBox ? (setOpenHelpBox(false), setHelpToggleCookie('close')) : ''
                }}>{hideInRight ? <i className="icon-comment-dots"></i> : <i className="icon-double-arrow-right"></i>}</span>
                <div className="chat-icon" onClick={() => {
                    setOpenHelpBox(!openHelpBox);
                    openHelpBox ? setHelpToggleCookie('close') : setHelpToggleCookie('open');
                }} role="button">{openHelpBox ? <i className="help-close icon-cross-icon"></i> : <i className="icon-comment-dots"></i>}</div>
            </div>
        </div>}
    </>);
}

export default HelpBox;